import request from "../../untils/request";

export function selectList(param) {

    return request({
        url: '/dictionary/selectList',
        method: 'get',
        params: param
    })
}

export function detail(param) {

    return request({
        url: '/dictionary',
        method: 'get',
        params: param
    })
}

export function add(data) {

    return request({
        url: '/dictionary',
        method: 'post',
        data: data
    })
}

export function remove(param) {

    return request({
        url: '/dictionary/'+param,
        method: 'delete',
    })
}
